import axios from 'axios'
import * as lodash from 'lodash';
import * as common from "@/common.js";

export const getDropdownItems = lodash.debounce((loading, url, dropdownCurrentId, dropdownDataGetSetCallBack) => {
    let dropdownCurrentData = dropdownDataGetSetCallBack() //get
    let currentIdName = dropdownCurrentData.find(x => x.id == dropdownCurrentId);

  axios.get(url).then(res => {
        dropdownCurrentData = res.data;

        if (currentIdName != null //don't add if null
            && res.data.find(x => x.id == currentIdName.id) == null) { //dont add if already exists on the list
            dropdownCurrentData.push(currentIdName);
        }

        dropdownDataGetSetCallBack(dropdownCurrentData); //set
        loading(false);
  }).catch(error => {
        if (currentIdName != null) {
            dropdownCurrentData = [currentIdName]; //preserve last value on error
        }
        else {
            dropdownCurrentData = []; //empty if last value not present
        }

        dropdownDataGetSetCallBack(dropdownCurrentData); //set
        loading(false);
    });
}, 500); //this delay should be passed as arg so we can controll for every use case

export const getDropdownItemsEmpty = lodash.debounce((loading, url, dropdownCurrentId, dropdownDataGetSetCallBack) => {
  let dropdownCurrentData = dropdownDataGetSetCallBack() //get
  let currentIdName = dropdownCurrentData.find(x => x.id == dropdownCurrentId);

  if (currentIdName != null) {
    dropdownCurrentData = [currentIdName]; //preserve last value on error
  }
  else {
    dropdownCurrentData = []; //empty if last value not present
  }

  dropdownDataGetSetCallBack(dropdownCurrentData); //set
  loading(false);
}, 500); //this delay should be passed as arg so we can controll for every use case

export function getCarriers(loading, userSearch, originationReason, currentCarrierId, dropdownDataGetSetCallBack) {
    let url = `bix/carriers?originationReason=${originationReason}&term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentCarrierId, dropdownDataGetSetCallBack);
};

export function getCommissionPaidNames(loading, userSearch, billingCarrierType, originationReason, currentBillingCarrierId, dropdownDataGetSetCallBack) {
    let url = `bix/carriers/commission-paid-by?originationReason=${originationReason}&billingCarrierType=${billingCarrierType}&term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentBillingCarrierId, dropdownDataGetSetCallBack);
};

export function getRegions(loading, userSearch, currentRegionId, dropdownDataGetSetCallBack) {
    let url = `bix/regions?term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentRegionId, dropdownDataGetSetCallBack);
};

export function getAllRegions() {
  let url = `bix/allRegions`;
  return axios.get(url).then((response) => {
    return response.data;
  }).catch(error => {
    return errorCallback(error);
  });
};

export function getDivisions(loading, userSearch, regionId, currentOfficeId, dropdownDataGetSetCallBack) {
    let url = `bix/regions/${regionId}/divisions?term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentOfficeId, dropdownDataGetSetCallBack);
};

export function getDepartments(loading, userSearch, officeId, currentDepartmentId, dropdownDataGetSetCallBack) {
    let url = `bix/divisions/${officeId}/departments?term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentDepartmentId, dropdownDataGetSetCallBack);
};

export function getBroker(loading, userSearch, currentBrokerId, dropdownDataGetSetCallBack) {
  let url = `bix/brokers?term=${escape(userSearch)}`;
    getDropdownItems(loading, url, currentBrokerId, dropdownDataGetSetCallBack);
}

export function getDynamicsUsers(loading, userSearch, searchingBU, currentUserId, dynamicsInstanceName, dropdownDataGetSetCallBack) {
  let url = `dynamics/users/${dynamicsInstanceName}?term=${escape(userSearch)}&searchingBU=${searchingBU}`;
  getDropdownItems(loading, url, currentUserId, dropdownDataGetSetCallBack)
}

export function getCountryStatesBP(countryName, dropdownDatSetCallBack) {
    let global = common.Singleton.getInstance();
    let statesForCountry = null;

    if (global.states) {
        statesForCountry = global.states.find(x => x.name == countryName);
    }
    else {
        global.states = new Array();
    }

    if (statesForCountry) {
        dropdownDatSetCallBack(statesForCountry.data); //set
    }
    else {

        axios.get(`bix/states?country=${countryName}`).then(res => {
            global.states.push({ name: countryName, data: res.data });
            dropdownDatSetCallBack(res.data); //set
        }).catch(error => {
            console.log(error); //what else?
        });
    }
}

export function getCountryStatesEPIC(countryName, epicDestination, dropdownDatSetCallBack) {
  let global = common.Singleton.getInstance();
  let statesForCountry = null;

  if (global.EPICstates) {
    statesForCountry = global.EPICstates.find(x => x.name == countryName);
  }
  else {
    global.EPICstates = new Array();
  }

  if (statesForCountry) {
    dropdownDatSetCallBack(statesForCountry.data); //set
  }
  else {

    axios.get(`echos/states?countryCode=${countryName}&epicDestination=${epicDestination}`).then(res => {
      global.EPICstates.push({ name: countryName, data: res.data });
      dropdownDatSetCallBack(res.data); //set
    }).catch(error => {
      console.log(error); //what else?
    });
  }
}

export function getDynamicsContactByBpId(bpId, dynamicsInstanceName, callBack){
    axios.get(`dynamics/${dynamicsInstanceName}/contact/bp/${bpId}`).then(res => {
        callBack(res.data);
    }).catch(error => {
        console.log(error);
    });
}

export function getDynamicsAccountByBpId(bpId, dynamicsInstanceName, callBack){
    axios.get(`dynamics/${dynamicsInstanceName}/account/bp/${bpId}`).then(res => {
        callBack(res.data);
    }).catch(error => {
        console.log(error);
    });
}

export function getUsageStats(monthyear, aggregateBy, activityType, businessUnit, user, callback){
  let qs = `statistics?MonthYear=${monthyear}&AggregateBy=${aggregateBy}&ActivityType=${activityType}`;
  if(businessUnit !== null && businessUnit !== undefined){
    qs = `${qs}&BusinessUnit=${businessUnit}`;
  }
  if(user !== null && user !== undefined){
    qs = `${qs}&UserEmail=${user}`;
  }
  axios.get(qs).then(res => {
    callback(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getBusinessUnits(monthyear, callback) {
  axios.get(`statistics/lookups/business-units/${monthyear}`).then(res => {
    callback(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getUsersForBusinessUnit(monthyear, businessUnit, callback) {
  let qs = `statistics/lookups/users`;
  if(businessUnit !== null && businessUnit !== undefined){
    qs = `${qs}/${businessUnit}/${monthyear}`;
  }else {
    qs = `${qs}/all/${monthyear}`;
  }

  axios.get(qs).then(res => {
    callback(res.data);
  }).catch(error => {
    console.log(error);
  });
}

export function getMonthsWithStatistics(callback){
    axios.get("statistics/months").then(res => {
        callback(res.data);
    }).catch(error => {
        console.log(error);
    });
}
